(() => {
    const header = $('.header');
    if (!header.length) {
        return;
    }
    const fixedHeader = header.clone();
    fixedHeader.addClass('is-fixed');
    fixedHeader.removeClass('main-header');
    fixedHeader.find('.hide-on-fixed').remove();
    fixedHeader.css('display', 'none');

    header.after(fixedHeader);

    const checkBodyPosition = () => {
    };
    const checkMenuItems = () => {
        if ($(window).width() < $('#default-grid').outerWidth()) {
            fixedHeader.addClass('fix-container');
        } else {
            fixedHeader.removeClass('fix-container');
        }
    };
    const checkHeaderPosition = () => {
        let breakP = $('.main-header').height() + 50;
        if (typeof window._is_mobile !== "undefined" && window._is_mobile) {
            breakP = $('.main-header').height() + ($(window).height() / 3.5);
        }

        if ($(window).scrollTop() > breakP) {
            fixedHeader.stop().fadeIn('fast');
        } else if ($(window).scrollTop() <= breakP) {
            fixedHeader.stop().fadeOut('fast');
        }
    };

    $(window).on('scroll', function () {
        checkHeaderPosition();
    });
    $(window).on('resize', function () {
        checkBodyPosition();
        checkMenuItems();
    });

    checkBodyPosition();
    checkHeaderPosition();
    checkMenuItems();

})();
